import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";

/**
 * Reads ?voucher=CODE from the URL (e.g. from a scanned QR).
 * Stores the code in sessionStorage and shows a toast.
 * The checkout flow picks it up from sessionStorage.
 */
export default function useVoucherFromUrl() {
  const [params, setParams] = useSearchParams();
  const applied = useRef(false);

  useEffect(() => {
    const code = params.get("voucher");
    if (!code || applied.current) return;
    applied.current = true;
    sessionStorage.setItem("biga_voucher", code.toUpperCase());
    toast.success(`Voucher ${code.toUpperCase()} saved — it'll be added at checkout`, { duration: 5000 });
    // Remove the param from URL without reload
    params.delete("voucher");
    setParams(params, { replace: true });
  }, [params, setParams]);
}
